import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import * as mockData from "../data/mock";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SiteConfigContext = createContext(null);

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const res = await axios.get(`${API}/site-config`, {
        headers: { 'Cache-Control': 'no-cache' },
        params: { _t: Date.now() },
      });
      setConfig(res.data);
    } catch (err) {
      console.warn("Failed to fetch site config, using mock data", err);
      setConfig({
        general: {
          name: mockData.siteInfo.name,
          tagline: mockData.siteInfo.tagline,
          phone: mockData.siteInfo.phone,
          email: mockData.siteInfo.email,
          location: mockData.siteInfo.location,
          hours: mockData.siteInfo.hours,
          images: mockData.images,
        },
        home: {
          stats: mockData.stats,
          whyChooseUs: mockData.whyChooseUs,
        },
        services: mockData.services,
        audiences: mockData.audiences,
        howItWorks: mockData.howItWorksSteps,
        faq: mockData.faqItems,
        serviceOptions: mockData.serviceOptions,
        about: {},
      });
    } finally {
      setLoading(false);
    }
  };

  const refreshConfig = () => fetchConfig();

  // Helper accessors
  const general = config?.general || {};
  const images = general?.images || mockData.images;
  const siteInfo = {
    name: general?.name || mockData.siteInfo.name,
    tagline: general?.tagline || mockData.siteInfo.tagline,
    phone: general?.phone || mockData.siteInfo.phone,
    email: general?.email || mockData.siteInfo.email,
    location: general?.location || mockData.siteInfo.location,
    hours: general?.hours || mockData.siteInfo.hours,
  };

  return (
    <SiteConfigContext.Provider
      value={{
        config,
        loading,
        refreshConfig,
        images,
        siteInfo,
        services: config?.services || mockData.services,
        audiences: config?.audiences || mockData.audiences,
        howItWorks: config?.howItWorks || mockData.howItWorksSteps,
        faq: config?.faq || mockData.faqItems,
        home: config?.home || {},
        about: config?.about || {},
        serviceOptions: config?.serviceOptions || mockData.serviceOptions,
        footer: config?.footer || {},
      }}
    >
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => {
  const ctx = useContext(SiteConfigContext);
  if (!ctx) throw new Error("useSiteConfig must be used within SiteConfigProvider");
  return ctx;
};
